var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44794 8.97001C6.59941 7.60343 7.24957 6.34072 8.27396 5.4236C9.29835 4.50649 10.625 3.99939 11.9999 3.99939C13.3749 3.99939 14.7015 4.50649 15.7259 5.4236C16.7503 6.34072 17.4005 7.60343 17.5519 8.97001L17.8039 11.236L17.8099 11.293C17.939 12.417 18.3051 13.5009 18.8839 14.473L18.9139 14.523L19.4909 15.486C20.0159 16.36 20.2779 16.797 20.2209 17.156C20.1833 17.3943 20.0608 17.6109 19.8759 17.766C19.5969 18 19.0869 18 18.0679 18H5.93194C4.91194 18 4.40194 18 4.12394 17.767C3.93855 17.6119 3.81563 17.3948 3.77794 17.156C3.72194 16.797 3.98394 16.36 4.50794 15.486L5.08694 14.522L5.11694 14.472C5.6953 13.5001 6.06101 12.4166 6.18994 11.293L6.19594 11.236L6.44794 8.97001Z",
    stroke: "#505762",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10205 18.406C9.27305 19.15 9.65005 19.808 10.1741 20.276C10.6981 20.746 11.3401 21 12.0001 21C12.6601 21 13.3021 20.746 13.8261 20.277C14.3501 19.807 14.7261 19.15 14.8981 18.406",
    stroke: "#505762",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a7d0323963bff479a5c6e09687ddbb34.svg";
export { ForwardRef as ReactComponent };